import { render, staticRenderFns } from "./MonitoramentoOperacaoCdaWa.vue?vue&type=template&id=54c7a898&lang=pug"
import script from "./MonitoramentoOperacaoCdaWa.vue?vue&type=script&lang=js"
export * from "./MonitoramentoOperacaoCdaWa.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoOperacaoCdaWa.vue?vue&type=style&index=0&id=54c7a898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports